import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';
import { User } from '../interfaces/userModel';
import { jwtDecode } from "jwt-decode";
@Injectable({
  providedIn: 'root'
})
export class LoginService extends DataService {

  @Output() contextChange: EventEmitter<boolean> = new EventEmitter();
  private url = environment.apiUrl + 'api/';
  userKey = 'user';
  public isLoggingOut = false;
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  register(model: any) {
    return this.httpClient.post(this.url + 'Authentication/registerUser', model);
  }
  login(model: any) {
    return this.httpClient.post(this.url + 'Authentication/login', model);
  }
  changePassword(model: any) {
    return this.httpClient.post(this.url + 'Authentication/changePassword', model);
  }
  registerPassword(model: any) {
    return this.httpClient.post(this.url + 'Authentication/confirmRegistration', model);
  }
  updateUser(model: any) {
    return this.httpClient.post(this.url + 'Authentication/updateUser', model);
  }
  forgotPassword(model: any) {
    return this.httpClient.post(this.url + 'Authentication/forgotPassword', model);
  }
  resetPassword(model: any) {
    return this.httpClient.post(this.url + 'Authentication/resetPassword', model);
  }
  encriptCredentials(model: any) {
    return this.httpClient.post(this.url + 'Authentication/encriptCredentials', model);
  }
  decriptCredentials(Password: string) {
    return this.httpClient.post(this.url + 'Authentication/decriptCredentials', { Password });
  }
  google(idToken: string) {
    return this.httpClient.post(this.url + 'Authentication/google', { idToken });
  }
  facebook(authToken: string) {
    return this.httpClient.post(this.url + 'Authentication/facebook', { authToken });
  }
  setUser(user: any) {
    localStorage.setItem(this.userKey, JSON.stringify(user));
    this.contextChange.emit(true);
  }

  getUser(): User {
    const user = localStorage.getItem(this.userKey);
    if (!user) {
      return null as any;
    }

    const userJson = JSON.parse(user);
    if (!userJson) {
      return null as any;
    }

    const usr = userJson;
    return usr;
  }

  isAuthenticated(): boolean {
    const token = this.getUser();
    return !!token;
  }

  logout() {
    localStorage.removeItem(this.userKey);
    this.contextChange.emit(false);
  }

  getToken() {
    const user = localStorage.getItem(this.userKey);
    if (!user) {
      return null;
    }

    const userJson = JSON.parse(user);
    if (!userJson) {
      return null;
    }

    return userJson.Token;
  }
  isAdmin() {

    var token = this.getToken();
    if (token != null) {

      const decoded = jwtDecode<any>(token)
      if (decoded.role == "Admin") {
        return true;
      }
      else {
        return false;
      }

    }
    else {
      return false;
    }
  }

  saveCredentials(email: any, pass: any) {
    localStorage.setItem("encryptedPassword", pass);
    localStorage.setItem("email", email);
  }

  removeCredentials() {
    localStorage.setItem("encryptedPassword", '{}');
    localStorage.setItem("email", '{}');
  }

  getCredentials() {
    var pass = JSON.parse(localStorage.getItem('encryptedPassword') || '{}');
    var email = localStorage.getItem('email');
    return { email, pass };
  }


}